<template lang="html">
  <div>
    <div
      id="video"
      class="video-carousel carousel slide"
      data-ride="carousel"
      data-interval="false"
    >
      <div ref="vblock" style="position: relative" v-if="has_answers">
        <div v-for="(question, index) in questions" :key="question.id">
          <vrecursive-block
            class="recursive-block"
            v-if="!is_video_started && !first_click_was"
            :count="questions.length - 1"
            :current_index="index"
            :handle_click="first_play_click"
          >
            <div class="play_first">play</div>
          </vrecursive-block>
          <div
            class="response-player-wrapper"
            :class="['response-player-' + videoOrientaion]"
            v-if="!is_not_video(question)"
          >
            <player
              :class="{ vphide: num !== index }"
              :ref="'player_' + index"
              :src="question.video ? question.video.source : ''"
              :poster="question.video ? question.video.preview : ''"
              :muted="config.muted"
              :rate="config.rate"
              :index="index"
              :volume="config.volume"
              :isFluid="true"
              class="response-player"
              @inited="set_controls"
              @changed="save_config"
              @ended="next_answer"
              @play="set_answer_state(index, true)"
              @paused="set_answer_state(index, false)"
            />
          </div>
          <div v-else :class="{ vphide: num !== index }">
            <div class="dummy">
              <img src="/static/images/elements/dummy-video.svg" />
              <div class="dummy-description">
                {{ dummy_video_description(question) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-wrapper">
        <emotions
          class="flex-wrapper_left"
          v-if="isEmotionsVisible"
          :video="currentItem.video"
        />
        <vpaginator
          v-if="has_video_answers"
          :show_prev_btn="show_prev_btn"
          :show_next_btn="show_next_btn"
          :first="num === first_num_with_video"
          :last="num === last_num_with_video"
          @next="next_answer"
          @prev="prev_answer"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import player from '@/routes_new/inner/response/components/player.vue';
  import vpaginator from '@/routes_new/inner/response/components/video_paginator.vue';
  import Emotions from './Emotions.vue';

  export default {
    name: 'process-response-videointerview-scene',

    components: {
      player,
      vpaginator,
      Emotions
    },

    props: {
      questions: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        autoPlayNext: true,
        defaultPlaybackRate: 1,
        volume: 1,
        playclick_count: 0,
        num: 0,
        config: {
          muted: false,
          rate: 1,
          volume: 1
        },
        controls: []
      };
    },

    methods: {
      first_play_click(val, current_index) {
        if (this.questions[val].video === null) {
          return;
        }
        if (this.is_video_started || this.first_click_was) {
          return;
        }

        // На iOs при первом клике на вопрос выполянется мгновенный play, затем pause и unmute всех видео вопросов.
        // Сделано, чтобы на iOs корректно отрабатывало автопереключение видео
        // if (this.isIos || this.isSafari) {

        let result = this.controls.find(control => control.index === val);
        if (result) {
          result.play();
        }

        if (this.num !== val) {
          if (result) {
            result.pause();
          }
        }
        this.playclick_count = this.playclick_count + 1;
        if (result !== null) {
          if (this.playclick_count === this.questions.length - 1) {
            this.$store.commit(
              'interview/videointerview/set_first_click_was',
              true
            );
          }
          if (this.playclick_count >= this.questions.length) {
            this.$store.commit(
              'interview/videointerview/toggle_start_video',
              true
            );
            this.$store.commit('vacancy/videointerview/setIndex', this.num);
          }
        }
      },
      change_volume(v) {
        this.volume = v;
      },
      change_muted(v) {
        this.muted = v;
      },
      next_answer() {
        const next_control = this.controls.find(
          control => control.index === this.num
        );
        if (next_control) {
          next_control.pause();
        }

        let has_next_video = false;

        for (let i = this.num + 1; i <= this.questions.length - 1; i++) {
          if (this.questions[i].video !== null) {
            has_next_video = true;
          }
        }

        if (!has_next_video) {
          return;
        }

        if (this.num < this.questions.length - 1) {
          let result = this.controls.find(
            control => control.index === this.num + 1
          );
          if (result) {
            result.play(0); // time start 0
          } else {
            this.num++;
            return this.next_answer();
          }
          let has_video = false;
          for (let i = this.num + 1; i < this.questions.length; i++) {
            if (this.questions[i].video !== null) {
              has_video = true;
            }
          }
          if (has_video) {
            this.num++;
            if (result === null) {
              this.next_answer();
              return;
            }
            this.$store.commit('vacancy/videointerview/setIndex', this.num);
          }
        } else {
          this.$store.commit('vacancy/videointerview/set_playing', false);
        }
      },

      prev_answer() {
        const prev_control = this.controls.find(
          control => control.index === this.num
        );
        if (prev_control) {
          prev_control.pause();
        }
        if (this.num > 0) {
          this.num--;
          let result = this.controls.find(
            control => control.index === this.num
          );
          if (result) {
            result.play(0); // time start 0
          } else {
            return this.prev_answer();
          }
          this.$store.commit('vacancy/videointerview/setIndex', this.num);
        } else {
          this.$store.commit('vacancy/videointerview/set_playing', false);
        }
      },

      set_controls(controls) {
        const index = controls.index;
        if (this.questions[index].video !== null) {
          this.controls.push(controls);
        }
      },
      save_config(data) {
        // volume, muted, rate
        this.config.volume = data.volume;
        this.config.muted = data.muted;
        this.config.rate = data.rate;
      },
      set_answer_state(index, played) {
        if (this.num === index) {
          this.$store.commit('vacancy/videointerview/set_playing', played);
        }
      },

      set_active_answer(num) {
        let time;
        let control;
        if (this.num !== num) {
          control = this.controls.find(control => control.index === this.num);
          if (control) {
            control.pause();
          }
          time = 0;
        }
        this.num = num;
        control = this.controls.find(control => control.index === this.num);
        if (control) {
          control.play_pause(time);
        }
      },

      is_not_video(question) {
        if (!question || !question.video || !question.video.source) {
          return true;
        }

        return (
          this.is_question_blocked(question) ||
          this.is_video_error(question) ||
          this.is_question_skipped(question)
        );
      },

      is_question_skipped(question) {
        if (!question) {
          return true;
        }

        return question.is_question_skipped;
      },

      is_question_blocked(question) {
        if (!question) {
          return true;
        }

        return question.is_blocked;
      },

      is_video_error(question) {
        if (!question) {
          return true;
        }

        return question.is_video_error;
      },

      dummy_video_description(question) {
        return this.$tr('videoInterview.question.is_video_error');
      }
    },
    watch: {
      questionIndex(val) {
        this.num = val;
      }
    },
    computed: {
      first_num_with_video() {
        let result = 0;
        let list = this.questions.map(i => i.video);
        for (let i = 0; i < list.length; i++) {
          if (list[i] !== null) {
            result = i;
            break;
          }
        }
        return result;
      },
      last_num_with_video() {
        let result = 0;
        let list = this.questions.map(i => i.video);
        for (let i = list.length - 1; i >= 0; i--) {
          if (list[i] !== null) {
            result = i;
            break;
          }
        }
        return result;
      },
      has_answers() {
        return this.questions.length > 0;
      },
      has_video_answers() {
        if (!this.questions.length) {
          return false;
        }

        let has_video = false;
        this.questions.forEach(question => {
          if (question.video !== null) {
            has_video = true;
          }
        });
        return has_video;
      },
      show_prev_btn() {
        if (!this.questions || !this.questions.length) {
          return false;
        }
        let has_video = false;

        for (let i = this.num; i >= 0; i--) {
          if (this.questions[i].video !== null) {
            has_video = true;
          }
        }

        return has_video;
      },
      show_next_btn() {
        if (!this.questions || !this.questions.length) {
          return false;
        }
        let has_video = false;

        for (let i = this.num; i <= this.questions.length - 1; i++) {
          if (this.questions[i].video !== null) {
            has_video = true;
          }
        }

        return has_video;
      },
      is_video_started() {
        return this.$store.getters['interview/videointerview/is_video_started'];
      },
      first_click_was() {
        return this.$store.getters['interview/videointerview/first_click_was'];
      },
      questionIndex() {
        return this.$store.getters['vacancy/videointerview/index'];
      },
      selectedQuestion() {
        return this.questions[this.questionIndex]
          ? this.questions[this.questionIndex]
          : {};
      },
      videoOrientaion() {
        if (
          !this.selectedQuestion ||
          !this.selectedQuestion.video ||
          !this.selectedQuestion.video.width ||
          !this.selectedQuestion.video.height
        ) {
          return 'horizontal';
        }
        const video = this.selectedQuestion.video;

        return video.width / video.height > 1 ? 'horizontal' : 'vertical';
      },
      currentItem() {
        if (!this.questions || !this.questions.length) {
          return null;
        }
        return this.questions[this.questionIndex]
          ? this.questions[this.questionIndex]
          : null;
      },
      isEmotionsVisible() {
        return (
          this.currentItem &&
          this.currentItem.video &&
          this.currentItem.video.emotions &&
          this.currentItem.video.emotions.length !== 0
        );
      }
    },
    created() {
      for (let i = 0; i < this.questions.length; i++) {
        if (this.questions[i].video !== null) {
          this.num = i;
          break;
        }
      }
      this.$store.commit('vacancy/videointerview/setIndex', this.num);
      this.$emit('set_event_catcher', this.set_active_answer);
    },
    destroyed() {
      this.$store.commit('vacancy/videointerview/set_playing', false);
    }
  };
</script>

<style lang="scss" scoped>
  .carousel {
    margin-right: 0px;
    .recursive-block {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: transparent;
      opacity: 0;
      z-index: 999;
      cursor: pointer;
      .play_first {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        opacity: 0;
      }
    }
  }
  .loading,
  .error {
    text-align: center;
  }
  .vphide {
    overflow: hidden;
    height: 0 !important;
    opacity: 0;
    min-height: auto !important;
  }

  .dummy {
    background: #f2f2f2;
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .dummy-description {
    margin-top: 36px;
    max-width: 300px;
    // font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: #a7a7a7;
  }
  .flex-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 120px;
  }

  .flex-wrapper_left {
    margin-right: auto;
  }
  .flex-wrapper_right {
    margin-left: auto;

    ::v-deep &.videos-navigation {
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  .video-carousel {
    width: 600px;
  }
  .response-player-wrapper {
    background: #000;
    overflow: hidden;
    border-radius: 4px;
    display: block;

    &.response-player-vertical {
      ::v-deep .response-player {
        width: 360px;
        min-height: 480px;
        margin: 0 auto;

        .video-js {
          min-height: 480px;
        }
      }
    }
  }
</style>
